export { initSession } from 'next-flight-server-reference-proxy-loader?id=7fc6c3d0138a2c9b21d424fefb6d9e7aec22fb04c3&name=initSession!'